var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 80,
    viewBox: "0 0 70 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13190_141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.5533 71.41L70.93 0H0L0.0833333 0.926667L6.36667 71.42L6.42 72.0067L35.1967 80H35.65L64.4933 72L64.5467 71.4133L64.5533 71.41ZM35.5267 15.5967H56.1367L55.5167 22.7967L35.1833 31.8367L35.5233 33.4633H54.6033L52.4067 58.6333L35.4533 63.3333L18.5067 58.64L17.44 46.5867H24.4167L24.9767 52.6967L25.03 53.29L35.3133 56.0233H35.7567L45.9267 53.1967L45.9767 52.6067L46.9367 41.32L47.0133 40.4H16.8567L16.2233 33.1567L37.2533 24.1533L36.92 22.52H15.32L14.7033 15.5867H35.5033L35.5267 15.5967Z",
    fill: "#2B53E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13190_141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.15045825941bb714c9ca25cd17658786.svg";
export { ForwardRef as ReactComponent };